"use client";

import { useState } from "react";
import { ArrowRight, TestTube } from "lucide-react";
import { Button } from "@/shadcnComponents/ui/button";

export function SampleModeBanner() {
  const [isMinimized, setIsMinimized] = useState(false);

  if (isMinimized) {
    return (
      <div
        className="fixed top-4 right-4 bg-amber-100 text-amber-800 rounded-full p-2 shadow-md cursor-pointer z-50 animate-pulse"
        onClick={() => setIsMinimized(false)}
      >
        <TestTube className="h-5 w-5" />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-full p-4">
      <div className="bg-amber-100 border border-amber-200 rounded-lg shadow-lg overflow-hidden">
        <div className="flex items-center justify-between px-4 py-2 bg-amber-200">
          <div className="flex items-center gap-2">
            <TestTube className="h-5 w-5 text-amber-700" />
            <span className="font-semibold text-amber-800">
              You're in Sample Mode
            </span>
          </div>
          <button
            onClick={() => setIsMinimized(true)}
            className="text-amber-700 hover:text-amber-900"
            aria-label="Minimize"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
        </div>

        <div className="p-4 bg-amber-50">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-left w-full md:w-auto">
              <p className="text-amber-800 text-sm">
                🧪 Try everything using mock profiles and sample stats. Some
                actions are restricted. To do more, create a new, real campaign.
              </p>
            </div>

            <div className="flex-shrink-0 w-full md:w-auto text-right">
              <Button
                variant="default"
                size="sm"
                onClick={() => {
                  localStorage.removeItem("jwtToken");
                  localStorage.removeItem("userType");
                  window.open("/brand/signup", "_self");
                }}
                className="bg-amber-500 hover:bg-amber-600 text-white flex items-center gap-1 ml-auto md:ml-0"
              >
                Exit Sample Mode <ArrowRight className="h-4 w-4 ml-1" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
